import moment from "moment";

const CATS = [
  {
    title: "Saves",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "saves")?.value;
    },
  },
  {
    title: "Goals prevented",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "blockedScoringAtt")?.value;
    },
  },
  {
    title: "Throws",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "keeperThrows")?.value;
    },
  },
  {
    title: "Punches",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "punches")?.value;
    },
  },
  {
    title: "Accurate passes",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "accuratePass")?.value;
    },
  },
  {
    title: "Touches",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "touches")?.value;
    },
  },
  {
    title: "Clearances",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalClearance")?.value;
    },
  },
  {
    title: "Tackles won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "wonTackle")?.value;
    },
  },
  {
    title: "Ground duels won",
    calc: ({ stats }) => {
      return (
        stats?.find((s) => s?.type === "duelWon")?.value -
        stats?.find((s) => s?.type === "aerialWon")?.value
      );
    },
  },
  {
    title: "Aerial duels won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "aerialWon")?.value;
    },
  },
  {
    title: "Fouls committed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "fouls")?.value;
    },
  },
  {
    title: "Chances created",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalAttAssist")?.value;
    },
  },
  {
    title: "Dispossessed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "dispossessed")?.value;
    },
  },
  {
    title: "Fouled",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "wasFouled")?.value;
    },
  },
  {
    title: "Shots",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalScoringAtt")?.value;
    },
  },
  {
    title: "Shots on target",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ontargetScoringAtt")?.value;
    },
  },
  {
    title: "Touches in Opp box",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "touchesInOppBox")?.value;
    },
  },
  {
    title: "Offsides",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalOffside")?.value;
    },
  },
  {
    title: "Goals",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "goals")?.value;
    },
  },
];

const DFB_CATS = [
  {
    title: "Saves",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "GoalkeeperSaves")?.value;
    },
  },
  {
    title: "Goals prevented",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsAtGoalBlocked")?.value;
    },
  },
  {
    title: "Accurate passes",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "PassesSuccessfulSum")?.value;
    },
  },
  {
    title: "Touches",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "BallActions")?.value;
    },
  },
  {
    title: "Clearances",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "DefensiveClearances")?.value;
    },
  },
  {
    title: "Tackles won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "TacklingGamesWon")?.value;
    },
  },
  {
    title: "Ground duels won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "TacklingGamesGroundWon")?.value;
    },
  },
  {
    title: "Aerial duels won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "TacklingGamesAirWon")?.value;
    },
  },
  {
    title: "Fouls committed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "FoulsSum")?.value;
    },
  },
  {
    title: "Chances created",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "AssistsShotAtGoal")?.value;
    },
  },
  {
    title: "Dispossessed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "AbandonmentsOfBall")?.value;
    },
  },
  {
    title: "Fouled",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "FoulsSuffered")?.value;
    },
  },
  {
    title: "Shots",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsAtGoalSum")?.value;
    },
  },
  {
    title: "Shots on target",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsOnTarget")?.value;
    },
  },
  {
    title: "Offsides",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "Offsides")?.value;
    },
  },
  {
    title: "Goals",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ShotsAtGoalSuccessfull")?.value;
    },
  },
];

// Opta F24 event typeIds that count toward a player's heatmap; 44, 59 and 67
// only count when outcome is 0, per the StatsPerform heatmap spec.
const OPTA_HEATMAP_EVENT_TYPES = [
  1, 2, 3, 4, 7, 8, 10, 11, 12, 13, 14, 15, 16, 41, 42, 44, 45, 49, 50, 51, 52,
  53, 54, 55, 56, 59, 60, 61, 67, 69, 72, 73, 74,
];
const OPTA_HEATMAP_OUTCOME_ZERO_ONLY_TYPES = [44, 59, 67];

export class PlayerHeatmap {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "PlayerHeatmap";
    this.cb_scene = "Player Heatmap";
    this.ff_scene = "FF Player Heatmap";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];
    if (options.full_frame) {
      this.scene = this.ff_scene;
    } else {
      this.scene = this.cb_scene;
    }
    if (options.type) {
      this.scene = this.scene + " " + options.type;
    }
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Title",
      value: {
        text: options.player.title || "",
      },
    });
    this.data.push({
      name: "Shirt Number",
      value: {
        text:
          options.player.shirt_number ?? options.player.opta_shirt_number ?? "",
      },
    });

    this.data.push({
      name: "Position",
      value: {
        text: options.player?.squad?.position ?? "",
      },
    });

    this.data.push({
      name: "Image",
      value: {
        image: "${user}" + options?.player?.image,
      },
    });

    this.data.push({
      name: "First Name",
      value: {
        text: options.player.first_name ?? options.player.opta_first_name ?? "",
      },
    });
    this.data.push({
      name: "Last Name",
      value: {
        text: options.player.last_name ?? options.player.opta_last_name ?? "",
      },
    });
    this.data.push({
      name: "First Name Uppercase",
      value: {
        text:
          options.player.first_name_upper ??
          options.player.opta_first_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase",
      value: {
        text:
          options.player.last_name_upper ??
          options.player.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Full Name",
      value: {
        text:
          (options.player.first_name ?? options.player.opta_first_name ?? "") +
          " " +
          (options.player.last_name ?? options.player.opta_last_name ?? ""),
      },
    });
    this.data.push({
      name: "Full Name Uppercase",
      value: {
        text:
          (options.player.first_name_upper ??
            options.player.opta_first_name?.toUpperCase() ??
            "") +
          " " +
          (options.player.last_name_upper ??
            options.player.opta_last_name?.toUpperCase() ??
            ""),
      },
    });

    this.data.push({
      name: "Nationality",
      value: {
        text:
          options?.player?.nationality?.code ??
          options?.player?.nationality?.opta_code,
      },
    });

    this.data.push({
      name: "Subtitle",
      value: {
        text: "",
      },
    });
    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    this.data.push({
      name: "Goal Time",
      value: {
        text: "",
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });

    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Type",
        value: {
          text: "home",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_text"
            ] || "",
        },
      });
      if (options?.game?.opta_ID) {
        this.buildStats({
          stats: options?.game?.opta_player_stats?.home?.find(
            (p) => p?.player === options?.player?.opta_ID,
          ),
        });
        this.buildOptaHeatmap({
          events: options?.opta_events,
          player: options?.player,
        });
      } else if (options?.game?.dfb_ID) {
        this.buildDFBStats({
          stats: options?.game?.sportec_player_stats?.home?.find(
            (p) => p?.player === options?.player?.dfb_ID,
          ),
        });
        this.buildDFBHeatmap({
          stats: options?.game?.sportec_player_stats?.home?.find(
            (p) => p?.player === options?.player?.dfb_ID,
          ),
        });
      }
      try {
        this.data.push({
          name: "xG",
          value: {
            text:
              parseFloat(
                options?.game?.opta_xg_player_stats?.home
                  ?.find((p) => p?.player === options?.player?.opta_ID)
                  ?.stats?.find((s) => s?.type === "expectedGoals")?.value ?? 0,
              )?.toFixed(2) || 0,
          },
        });
      } catch (err) {}
    } else {
      this.data.push({
        name: "Team Type",
        value: {
          text: "away",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_text"
            ] || "",
        },
      });
      if (options?.game?.opta_ID) {
        this.buildStats({
          stats: options?.game?.opta_player_stats?.away?.find(
            (p) => p?.player === options?.player?.opta_ID,
          ),
        });
        this.buildOptaHeatmap({
          events: options?.opta_events,
          player: options?.player,
        });
      } else if (options?.game?.dfb_ID) {
        this.buildDFBStats({
          stats: options?.game?.sportec_player_stats?.away?.find(
            (p) => p?.player === options?.player?.dfb_ID,
          ),
        });
        this.buildDFBHeatmap({
          stats: options?.game?.sportec_player_stats?.away?.find(
            (p) => p?.player === options?.player?.dfb_ID,
          ),
        });
      }
      try {
        this.data.push({
          name: "xG",
          value: {
            text:
              parseFloat(
                options?.game?.opta_xg_player_stats?.away
                  ?.find((p) => p?.player === options?.player?.opta_ID)
                  ?.stats?.find((s) => s?.type === "expectedGoals")?.value ?? 0,
              )?.toFixed(2) || 0,
          },
        });
      } catch (err) {}
    }

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  buildStats({ team, stats, options }) {
    CATS.map((cat) => {
      this.data.push({
        name: cat.title,
        value: {
          text: cat?.calc({ stats: stats.stats }) || 0,
        },
      });
    });
  }

  buildOptaHeatmap({ events, player }) {
    // Opta x/y arrive as 0-100 pitch percentages, so bin against that range,
    // but the Heat Map template renders directly onto the same 294x172
    // canvas buildDFBHeatmap uses - output cell centers in canvas units too,
    // or the data all lands crushed into one corner of the pitch graphic.
    const width = 100;
    const height = 100;
    const canvasWidth = 294;
    const canvasHeight = 172;
    const cols = 40;
    const rows = 28;

    const stepX = width / cols;
    const stepY = height / rows;
    const cellWidth = canvasWidth / cols;
    const cellHeight = canvasHeight / rows;

    const grid = new Array(cols * rows).fill(0);

    events
      ?.filter((e) => {
        if (e?.playerId !== player?.opta_ID) return false;
        if (!Number.isFinite(e?.x) || !Number.isFinite(e?.y)) return false;
        if (!OPTA_HEATMAP_EVENT_TYPES.includes(e?.typeId)) return false;
        if (OPTA_HEATMAP_OUTCOME_ZERO_ONLY_TYPES.includes(e?.typeId)) {
          return e?.outcome === 0;
        }
        return true;
      })
      ?.forEach((e) => {
        // Mirror y: Opta's y runs opposite to the flank orientation the
        // DFB-calibrated template expects, which was swapping LB/RB sides.
        const col = Math.min(cols - 1, Math.max(0, Math.floor(e.x / stepX)));
        const row = Math.min(
          rows - 1,
          Math.max(0, Math.floor((height - e.y) / stepY)),
        );
        grid[row * cols + col]++;
      });

    const totalCount = grid.reduce((sum, c) => sum + c, 0);

    const heatExport = [];
    for (let i = 0; i < grid.length; i++) {
      const count = grid[i];
      if (count === 0) continue;
      const col = i % cols;
      const row = Math.floor(i / cols);

      const x = col * cellWidth + cellWidth / 2;
      const y = row * cellHeight + cellHeight / 2;
      // Share of this player's total qualifying events, not share of their
      // busiest cell - normalizing to the max forced every player's top cell
      // to full heat even when it wasn't a real hotspot, washing wide areas
      // red. Capped so one small-sample freak cluster can't blow past
      // buildDFBHeatmap's ~0-10 range.
      const intensity = totalCount
        ? Math.min(10, (count / totalCount) * 50)
        : 0;

      heatExport.push([x, y, intensity]);
    }
    this.data.push({
      name: "Heatmap",
      value: { text: JSON.stringify(heatExport) },
    });
  }

  buildDFBHeatmap({ team, stats, options}) {
    const width = 294;
    const height = 172;
    const cols = 20;
    const rows = 14;

    const stepX = width / cols;
    const stepY = height / rows;

    const heatExport = [];
    const heatImport = stats?.heatmap?.data

    for (let i = 0; i < heatImport.length; i++) {
      const val = parseInt(heatImport[i]);
      if (val === 0) continue;
      const col = i % cols;
      const row = Math.floor(i / cols);

      const x = col * stepX + (stepX / 2);
      const y = row * stepY + (stepY / 2);
      const intensity = val / 10;

      heatExport.push([x, y, intensity])
    }
    this.data.push({
      name: "Heatmap",
      value: { text: JSON.stringify(heatExport) }
    });
  }

  buildDFBStats({ team, stats, options }) {
    DFB_CATS.map((cat) => {
      this.data.push({
        name: cat.title,
        value: {
          text: cat?.calc({ stats: stats.stats }) || 0,
        },
      });
    });
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
